import {timezz} from "timezz";

document.addEventListener('DOMContentLoaded', () => {
  const timer = document.querySelector('[data-countdown-target="timer"]');
  if (!timer) return;
  const dateString = timer.getAttribute('data-timestamp');

  // if timer date is in the past, hide the timer
  const date = new Date(dateString);
  if (date.getTime() < Date.now()) {
    timer.classList.add('hidden');
    return;
  }
  // set the timer
  timezz(timer, {
    date: dateString,
    stopOnZero: true,
  });
});
